import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const IMPOSIUM_COMPOSITION_ACTIONS = {
	GET_IMPOSIUM_COMPOSITIONS_AJAX: "GET_IMPOSIUM_COMPOSITIONS_AJAX",
	GET_IMPOSIUM_COMPOSITIONS_SUCCESS: "GET_IMPOSIUM_COMPOSITIONS_SUCCESS",
	GET_IMPOSIUM_COMPOSITIONS_ERROR: "GET_IMPOSIUM_COMPOSITIONS_ERROR",

	CLEAR_COMPOSITIONS: "CLEAR_COMPOSITIONS",
};

const initialState={
	items: [],
	error: null,
	isLoading: false,
	projectId: null,
	projectName: null,
};


//projectId is also called "story id" on the imposium side
export function getImposiumCompositions(libraryId, projectId, projectName) {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			payload: {
				projectId,
				projectName,
			},
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/project/${projectId}/compositions`,
				success: IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_SUCCESS,
				error: IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_ERROR,
			},
		});
	};
}

export function clearCompositions() {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_COMPOSITION_ACTIONS.CLEAR_COMPOSITIONS,
		});
	};
}


export const handlers = {
	[IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_AJAX]: getImposiumCompositionsRequest,
	[IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_SUCCESS]: getImposiumCompositionsSuccess,
	[IMPOSIUM_COMPOSITION_ACTIONS.GET_IMPOSIUM_COMPOSITIONS_ERROR]: getImposiumCompositionsError,

	[IMPOSIUM_COMPOSITION_ACTIONS.CLEAR_COMPOSITIONS]: reset,
};

function getImposiumCompositionsRequest(state, action) {
	return {
		...state,
		isLoading: true,
	};
}

function getImposiumCompositionsSuccess(state, action) {
	return {
		...state,
		items: action.payload?.data?.compositions || [],
		projectId: action.payload?.original?.projectId || null,
		projectName: action.payload?.original?.projectName || null,
		isLoading: false,
	};
}

function getImposiumCompositionsError(state, action) {
	return {
		...state,
		isLoading: false,
		error: action.payload.errorObj,
	};
}

function reset(state, action) {
	return {
		...initialState,
	};
}


let reducerConfig = {
	typeRoot: "IMPOSIUM_COMPOSITIONS",
	actionTypes: IMPOSIUM_COMPOSITION_ACTIONS,
	actionCreators: {
		clearCompositions,
		getImposiumCompositions,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, {});
reducerConfig = addColumnFilters(reducerConfig, {});

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const ImposiumCompositions = reducerConfig.actionCreators;
